<template>
  <div class="box">
    <div class="box-body form">
      <br />
      <div class="text-center">
        <h3 v-text="title" />
      </div>
    </div>
    <div>
      <div class="row fit gutter mx-auto">
        <div class="col-md-6 gutter">
          <div class="table-row">
            <div class="table-cell">
              <span class="text-red">＊ </span>名稱
            </div>
            <div class="table-from">
               <input class="form-control" placeholder="" type="text" v-model="adInfo.name" maxlength="45">
            </div>
          </div>
          <div v-if="bannerType === 41" class="table-row">
            <div class="table-cell">
              <span class="text-red">＊ </span>啟用
            </div>
            <div class="table-from">
              <select class="form-control" v-model="adInfo.is_active">
                <option value="1">啟用</option>
                <option value="0">停用</option>
              </select>
            </div>
          </div>
          <div v-if="bannerType !== 41" class="table-row">
            <div class="table-cell">
              <span class="text-red">＊ </span>排序
            </div>
            <div class="table-from">
              <input class="form-control" placeholder="" v-model="adInfo.sort" maxlength="99" type="tel" @keyup="veritySort" ref="sort">
            </div>
          </div>
          <div class="table-row">
            <div class="table-cell">
              <span class="text-red">＊ </span>你訂平台
            </div>
            <div class="table-from">
              <select class="form-control" v-model="adInfo.is_platform_visible">
                <option value="1">啟用</option>
                <option value="0">停用</option>
              </select>
            </div>
          </div>
          <div v-if="bannerType !== 41" class="table-row">
            <div class="table-cell">
              連結
            </div>
            <div class="table-from">
              <input class="form-control" placeholder="" type="text" v-model="adInfo.url" maxlength="100">
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="table-row">
            <div class="table-cell">
              <span class="text-red">＊ </span>開始時間
            </div>
            <div class="table-from">
              <date-time-picker :date="menuTime.start" :option="timeoption" :limit="startLimit"></date-time-picker>
            </div>
          </div>
          <div class="table-row">
            <div class="table-cell">
              <span class="text-red">＊ </span>結束時間
            </div>
            <div class="table-from">
              <date-time-picker :date="menuTime.end" :option="timeoption" :limit="endLimit"></date-time-picker>
            </div>
          </div>
          <div class="table-row">
            <div class="table-cell">
              <span class="text-red">＊ </span>街口平台
              <span data-toggle="tooltip" class="tip-icon" data-placement="bottom" title="與街口支付APP合作之你訂獨家功能，有興趣可洽業務窗口。若未簽約合作請勿啟用。">
                <i class="fa fa-question-circle" aria-hidden="true"></i>
              </span>
            </div>
            <div class="table-from">
              <select class="form-control" v-model="adInfo.is_jkos_visible">
                <option value="1">啟用</option>
                <option value="0">停用</option>
              </select>
            </div>
          </div>
          <div v-if="bannerType !== 41" class="table-row">
            <div class="table-cell">
                <span class="text-red">＊ </span>永久顯示
            </div>
            <div class="table-from">
              <select class="form-control" v-model="adInfo.foreverShow">
                  <option value="1">是</option>
                  <option value="0">否</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="bannerType !== 41" class="col-xs-12 input-group m-b-10">
          <span class="input-group-addon">
            <span class="text-red">＊ </span>廣告地區
            <span class="nd-tooltip">
              <ion-icon name="help-circle"></ion-icon>
              <span class="nd-tooltip-text center">
                *依據消費者位置指定廣告要出現的縣市(目前限台灣地區)。<br>
                *若無法判斷位置或在非台灣地區，則預設都顯示。
              </span>
            </span>
          </span>
          <div class="form-group m-0 p-5 text-left">
            <div class="radio inline-block">
              <label>
                <input type="radio" name="invoiceOption" :value="0" v-model="adInfo.is_limit_location">不限制
              </label>
            </div>
            <div class="radio inline-block">
              <label>
                <input type="radio" name="invoiceOption" :value="1" v-model="adInfo.is_limit_location">指定區域
              </label>
            </div>
          </div>
        </div>
        <div v-if="adInfo.is_limit_location" class="col-xs-12 input-group m-b-10">
          <span class="input-group-addon">
            <span class="text-red">＊ </span>指定區域
          </span>
          <multiselect
            class="min-w-150"
            v-model="adInfo.city_code_list"
            :options="getCityOption"
            :searchable="false"
            :allow-empty="true"
            :close-on-select="false"
            :show-labels="false"
            placeholder=""
            :multiple="true"
            label="name"
            track-by="code"
          />
        </div>
        <div class="col-xs-12 input-group">
          <span class="input-group-addon">
            <span class="text-red">＊ </span>圖片
          </span>
          <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
            <span class="inline-block h-auto m-t-5">
              <img
                v-if="!adInfo.image_web_file"
                class="img-responsive h-auto"
                :src="defaultImage"
              />
              <img
                v-if="adInfo.image_web_file"
                class="h-auto img-responsive"
                :src="adInfo.image_web_file"
                data-toggle="modal"
              />
            </span>
          </div>
          <div class="form-control h-100">
            <div>
              <label class="btn-upload btn btn-default m-t-25" style="margin-top: 8px;" for="brand-img-load">
                選擇圖片
              </label>
              <input class="form-control" type="file" style="display: none;" @change="onFileChange" id="brand-img-load">
            </div>
          </div>
        </div>
        <div
            class="text-right text-15 text-red"
            v-text="tipsImage"
          />
    </div>
    </div>


    <div class="box-footer text-center">
      <button class="btn btn-default" @click="$router.go(-1)">
        取消
      </button>
      <button class="btn btn-success" v-if="!info" @click="checkBeforeSend('cr')">
        新增
      </button>
      <button class="btn btn-success" v-if="info" @click="checkBeforeSend('up')">
        修改
      </button>
    </div>
    <br />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import $ from 'jquery'
import ImgUploadTemp from './ImgUploadTemp.vue'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
// import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'
// import 'src/static/js/plugins/notify/notify.min.js'
export default {
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      bannerType: Number(this.$route.query.tab) || 12,
      newPhoto: this.$route.query.new,
      img: {
        width: 0,
        height: 0
      },
      adInfo: {
        name: '',
        url: '',
        start_time: '',
        end_time: '',
        image_web_file: '',
        sort: 1,
        is_active: 1,
        is_platform_visible: 1,
        is_jkos_visible: 0,
        is_limit_location: 0,
        city_code_list: [],
        dedicated_visible_setting: [],
        foreverShow: 0
      },
      storeInfo: {},
      // time
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'font-size': '15px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 0px 0px 0px',
          'color': '#555',
          'text-align': 'left',
          'padding': '0px 12px',
          'line-height': '34px'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          from: moment().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss')
        }
      ]
    }
  },
  methods: {
    ...mapActions(['setCityList']),
    init () {
      // this.getStoreInfo()
      if (this.$route.name === 'upAd') this.getAdInfo()
    },
    veritySort () {
      var e = $(this.$refs.sort)
      this.adInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    getAdInfo () {
      var self = this
      var url = '/store/' + this.$route.params.store_id + '/banner/' + this.$route.params.ad_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const adInfo = response.data.info
          self.adInfo = {
            name: adInfo.name,
            url: adInfo.url.trim(),
            start_time: adInfo.start_time,
            end_time: adInfo.end_time,
            is_active: adInfo.is_active,
            image_web_file: adInfo.image_web,
            sort: adInfo.sort,
            is_platform_visible: adInfo.is_platform_visible,
            is_jkos_visible: adInfo.dedicated_visible_setting.indexOf(1) > -1 ? 1 : 0,
            foreverShow: 0,
            is_limit_location: adInfo.is_limit_location || 0,
            city_code_list: adInfo.city_code_list || []
          }
          if (adInfo.banner_type === 12) self.newPhoto = true
          self.menuTime.start.time = self.adInfo.start_time
          self.menuTime.end.time = self.adInfo.end_time
        }
      })
    },
    onFileChange (e) {
      this.imgLogoSelect = ''
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      let imgSize = Math.round(files[0].size / 1000)
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.createImage(files[0])
      }
    },
    createImage (file) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        self.adInfo.image_web_file = img.src
        img.onload = () => {
          self.img.width = img.width
          self.img.height = img.height
          self.checkImgSize()
        }
      }
      reader.readAsDataURL(file)
    },
    checkImgSize (type) {
      var self = this
      if ((this.img.width !== 1280 || this.img.height !== 300) && this.img.width !== 0 && this.img.height !== 0 && this.$route.query.tab === 11) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳1280x300之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if ((this.img.width !== 1000 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0 && this.$route.query.tab === 12) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳1000x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if ((this.img.width !== 480 || this.img.height !== 530) && this.img.width !== 0 && this.img.height !== 0 && this.$route.query.tab === 41) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳480x530之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      }
    },
    checkBeforeSend (type) {
      let all = this.getInput
      let msg = ''
      if (!all.name) {
        msg = '請輸入廣告名稱'
      } else if (!this.menuTime.start.time) {
        msg = '請輸入開始時間'
      } else if (!this.menuTime.end.time) {
        msg = '請輸入結束時間'
      } else if (!$('#brand-img-load')[0].files[0] && type === 'cr') {
        msg = '請上傳一張圖片'
      }
      this.getToast(msg, type)
    },
    getToast (msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (type === 'cr') this.createdAd()
        else if (type === 'up') this.updatedAdImg()
      }
    },
    getStoreInfo () {
      var self = this
      var url = '/store/' + this.$route.params.store_id + '/info'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeInfo = response.data.info
        }
      })
    },
    getBrandImgList () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list
          for (var i = 0; i < logoList.length; i++) {
            var option = {name: logoList[i].image_name, value: logoList[i].image_url}
            self.imgLogoOption.push(option)
          }
        }
      })
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3'
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list
          for (var j = 0; j < bgList.length; j++) {
            var option2 = {name: bgList[j].image_name, value: bgList[j].image_url}
            self.imgBgOption.push(option2)
          }
        }
      })
    },
    createdAd () {
      var self = this
      var data = new FormData()
      var info = this.getInput
      var name = info.name
      var picUrl = info.url
      var startTime = this.menuTime.start.time
      var endTime = this.menuTime.end.time
      var sort = parseInt(info.sort, 10)
      if (!picUrl) picUrl = ' '
      if (!this.newPhoto) data.append('banner_type', 11)
      else data.append('banner_type', this.bannerType)
      data.append('name', name)
      data.append('url', picUrl)
      data.append('start_time', startTime)
      data.append('end_time', endTime)
      data.append('sort', sort)
      data.append('is_active', this.adInfo.is_active)
      // icon 圖片
      data.append('image_web_file', $('#brand-img-load')[0].files[0])
      data.append('is_platform_visible', Number(this.adInfo.is_platform_visible))
      if (this.adInfo.is_jkos_visible) {
        data.append('dedicated_visible_setting[]', 1)
      } else {
        data.append('dedicated_visible_setting[]', null)
      }
      // 限制地區
      data.append('is_limit_location', this.adInfo.is_limit_location)
      if (this.adInfo.is_limit_location && this.adInfo.city_code_list.length) {
        this.adInfo.city_code_list.forEach(item => {
          data.append('city_code_list[]', item.code)
        })
      }
      var url = '/store/' + this.$route.params.store_id + '/banner'
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            self.$router.push({
              name: 'adTable',
              params: {
                brand_id: self.$route.params.brand_id,
                store_id: self.$route.params.store_id
              },
              query: {
                tab: self.bannerType
              }
            })
          }
        }, function (err) {
          console.error(err)
          self.handleError(err)
        })
      }
    },
    updatedAdImg () {
      var data = new FormData()
      // icon 圖片
      if ($('#brand-img-load')[0].files[0]) {
        data.append('image_web_file', $('#brand-img-load')[0].files[0])
        this.upImg(data, 1)
      } else this.updatedAd()
    },
    upImg (data, type) {
      var self = this
      var url = '/store/' + this.$route.params.store_id + '/banner/' + this.$route.params.ad_id + '/image'
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.updatedAd()
          }
        })
      }
    },
    updatedAd () {
      var self = this
      var info = this.getInput
      var data = {
        name: info.name,
        url: info.url,
        start_time: this.menuTime.start.time,
        end_time: this.menuTime.end.time,
        sort: info.sort,
        is_active: this.adInfo.is_active,
        is_platform_visible: this.adInfo.is_platform_visible,
        dedicated_visible_setting: [],
        is_limit_location: this.adInfo.is_limit_location
      }
      if (this.adInfo.is_limit_location && this.adInfo.city_code_list.length) {
        data.city_code_list = this.adInfo.city_code_list.map(item => { return item.code })
      }
      if (self.adInfo.is_jkos_visible === 1 || self.adInfo.is_jkos_visible === '1') {
        data.dedicated_visible_setting = [1]
      } else {
        data.dedicated_visible_setting = []
      }
      var url = '/store/' + this.$route.params.store_id + '/banner/' + this.$route.params.ad_id
      if (data) {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            self.$router.push({
              name: 'adTable',
              params: {
                brand_id: self.$route.params.brand_id,
                store_id: self.$route.params.store_id
              },
              query: {
                tab: self.bannerType
              }
            })
          }
        }, function (err) {
          self.handleError(err)
        })
      }
    },
    handleError (err) {
      let title = ''
      let text = ''
      if (err.response.data.status === 90055) {
        title = '錯誤訊息'
        text = '目前已有一進行中的蓋版廣告，若需更換廣告，請將進行中的廣告停用，再將欲上架的廣告啟用。'
      } else {
        title = err.response.data.message
        text = err.response.data.description
      }
      this.$notify({
        title: title,
        text: text,
        duration: 3000,
        type: 'danger',
        width: 400
      })
    }
  },
  created () {
    if (!this.getCityOption.length) {
      // 取得縣市列表
      this.setCityList()
    }
    this.init()
  },
  components: {
    'img-upload': ImgUploadTemp,
    'date-time-picker': datetimePicker,
    VueTimepicker
  },
  computed: {
    ...mapGetters(['getCityOption']),
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    },
    getInput () {
      var aInfo = this.adInfo
      for (let key in aInfo) {
        if (!aInfo[key] && typeof aInfo[key] === 'object') aInfo[key] = ' '
      }
      return {
        name: this.checkInput(aInfo.name.toString()),
        url: this.checkInput(aInfo.url.toString()),
        sort: this.checkInput(aInfo.sort.toString())
      }
    },
    defaultImage () {
      let url = ''
      switch (this.$route.query.tab) {
        case 12:
        case 41:
          url = ''
          break
        default:
          break
      }
      return url
    },
    tipsImage () {
      let size = ''
      let kb = '512'
      switch (this.$route.query.tab) {
        case 12:
          size = '1000x460'
          break
        case 41:
          size = '480x530'
          kb = '256'
          break
        default:
          break
      }
      return `圖片大小為 ${size} ${kb}KB 內`
    },
    title () {
      let title = ''
      switch (this.$route.query.tab) {
        case 12:
          title = '平台'
          break
        case 41:
          title = '蓋版'
          break
        default:
          break
      }
      return `${title}廣告資訊`
    }
  },
  watch: {
    'menuTime.start.time' () {
      this.endLimit = [
        {
          type: 'fromto',
          from: this.menuTime.start.time
        }
      ]
      // this.setMenuStartTime(this.menuTime.start.time)
    },
    'menuTime.end.time' () {
      this.startLimit = [
        {
          type: 'fromto',
          from: moment().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss'),
          to: this.menuTime.end.time
        }
      ]
      // this.setMenuEndTime(this.menuTime.end.time)
    },
    'adInfo.foreverShow' (val) {
      if (val) {
        this.menuTime.end.time = '2099-12-31 00:00:00'
      }
    },
    'adInfo.is_jkos_visible' (val) {
      if (val === '1') {
        this.adInfo.dedicated_visible_setting = [1]
      } else {
        this.adInfo.dedicated_visible_setting = []
      }
    }
  }
}
</script>
<style lang="sass" scoped>
</style>
<style scoped>
.table-row {
  margin-bottom: 10px;
  display: flex;
}
.table-cell{
  color: #FFF;
  background-color: #222d32;
  width: 200px;
  line-height: 34px;
  font-weight: bold;
  padding-left: 15px;
}
.table-from {
  width: 100%
}
.fit {
  width: fit-content;
  max-width: 900px;
}
.gutter {
  padding-right: 5px;
}
.mx-auto {
  margin: 0px auto;
}
</style>



// WEBPACK FOOTER //
// AdFormTemp.vue?2d52867d